import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { FilterModel } from 'src/Models/filterModel';
import { IPRModel } from 'src/Models/TrfaAlertsModel';
import { TrfaAlertService } from 'src/Services/alert.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-ipr-alerts',
  templateUrl: './ipr-alerts.component.html',
  styleUrls: ['./ipr-alerts.component.css']
})
export class IprAlertsComponent implements OnInit {
  tokenKey: string = '';
  isloading: boolean = false;
  filteModel = new FilterModel();;
  IPRModel: IPRModel[];
  IPRExportModel: IPRModel[];
  totalRecordCount: number = -1;
  isAscending: boolean;
  updateId: number = 0;

  upDownAlertDateCSS: string = '';
  upDownTitleCSS: string = '';
  upDownStatusCSS: string = '';
  upDownCreatedDateCSS: string = '';
  upDownModifiedDateCSS: string = '';
  Id: number = 0;
  IsSendEmail: boolean
  productId: number;
  openMenuIndex: number = -1;

  constructor(private readonly toastr: ToastrService,
    private readonly router: Router,
    private readonly trfaAlertServices: TrfaAlertService,
    private readonly titleService: Title,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.productId = ToolEnum.ipr;
    this.titleService.setTitle('iPR Alerts');
  }

  ngOnInit() {
    this.filteModel.pageNumber = '1';
    this.filteModel.pageSize = '10';
    this.filteModel.keywordFilter = '';
    this.filteModel.productId = this.productId;
    this.filteModel.orderBy = 'updateId ASC';
    this.filteModel.updateId = 0;
    this.GetIPRAlertsFindByPages();
  }


  GetIPRAlertsFindByPages() {
    this.isloading = true;
    this.IPRModel = [];
    if (this.filteModel.keywordFilter == "null") this.filteModel.keywordFilter = " ";
    this.filteModel.IsExport = false;
    this.trfaAlertServices.GetIPRAlertsFindByPagesV2(this.tokenKey, this.filteModel).subscribe(data => {
      if (data['status'] == 'Success') {
        this.isloading = false;
        this.IPRModel = data['iprAlertList'];
        if (this.IPRModel != null) {
          if (this.IPRModel.length > 0) {
            this.totalRecordCount = +this.IPRModel[0].totalRowCount;
          }
          else {
            this.totalRecordCount = 0;
          }
        }
      }
      else {
        this.showMessage(data['status'], 'Error', 'error');
      }

    },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }


  keywordFilters($event) {
    this.filteModel.keywordFilter = $event.target.value;
    if ($event.target.value != "" && $event.target.value != null) {
      this.filteModel.keywordFilter = $event.target.value;
    }
    else { this.filteModel.keywordFilter = ''; }

    this.filteModel.pageNumber = '1';
    this.GetIPRAlertsFindByPages();
  }

  sort(sortBy: any) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.filteModel.orderBy = sortBy + ' DESC';
      this.setDescCSS(sortBy);
    }
    else {
      this.isAscending = false;
      this.filteModel.orderBy = sortBy;

      this.setAscCSS(sortBy);
    }
    this.filteModel.pageNumber = '1';
    this.GetIPRAlertsFindByPages();
  }

  setDescCSS(sortBy) {
    if (sortBy === "updateDate") {
      this.upDownAlertDateCSS = 'fa fa-arrow-down';
      this.upDownTitleCSS = '';
    }
    else if (sortBy === "providerName") {
      this.upDownAlertDateCSS = '';
      this.upDownTitleCSS = 'fa fa-arrow-down';
    }
  }

  setAscCSS(sortBy) {
    if (sortBy === "updateDate") {
      this.upDownAlertDateCSS = 'fa fa-arrow-up';
      this.upDownTitleCSS = '';
    }
    else if (sortBy === "providerName") {
      this.upDownAlertDateCSS = '';
      this.upDownTitleCSS = 'fa fa-arrow-up';
    }
  }

  pageChanged($event) {
    this.filteModel.pageNumber = parseInt($event.page).toString();
    this.GetIPRAlertsFindByPages();
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  redirectToEditView(updateId: any) {
    this.router.navigate(['/admin/ipr/ipr-Alerts/user/' + updateId]);
  }

  SetCancelMailId(updateId: any) {
    this.Id = updateId;
  }

  CancelMail() {
    this.trfaAlertServices.notsentAlertmail(this.tokenKey, this.Id, this.productId).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.showMessage('', 'Success', 'success');
          this.GetIPRAlertsFindByPages();
        }
        else
          this.showMessage(data['status'], 'Error', 'error');
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportIPRAlert() {
    this.isloading = true;
    this.IPRExportModel = [];
    if (this.filteModel.keywordFilter == "null") this.filteModel.keywordFilter = " ";
    this.filteModel.IsExport = true;
    this.trfaAlertServices.GetIPRAlertsFindByPagesV2(this.tokenKey, this.filteModel).subscribe(data => {
      if (data['status'] == 'Success') {
        this.IPRExportModel = data['iprAlertList'];
        if (this.IPRExportModel != null) {
          if (this.IPRExportModel.length > 0) {
            setTimeout(() => {
              this.DownloadIPRAlert();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else {
          this.isloading = false;
          this.toastr.error("No record found", "Error");
        }
      }
      else {
        this.isloading = false;
        this.showMessage(data['status'], 'Error', 'error');
      }

    },
      error => {
        this.isloading = false;
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  DownloadIPRAlert() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportIPRAlerts';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportIPRAlerts.xls");
  }
}
